export default {
  IS_LOGIN_SSO: 'is-login-sso',
  IS_NEW_MENU: 'is-new-menu',
}
